var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class IossRegistration {
  /**
   * Creates an instance of IossRegistration.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof IossRegistration
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param FinalizeUploadRq_ _finalizeUploadRq
   * @returns Promise<FinalizeUploadRq_>
   * @memberof IossRegistration
   */
  finalizeUpload(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/IossRegistration/Finalize", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadRegistrationDocumentRq_ _downloadRegistrationDocumentRq
   * @returns Promise<DownloadRegistrationDocumentRq_>
   * @memberof IossRegistration
   */
  downloadRegistrationDocument(pDownloadRegistrationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/IossRegistration/Registration/Documents/{documentId}",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addQueryParams([{ name: "type", value: pDownloadRegistrationDocumentRq.type }]);
    client.addPathParams([{ name: "documentId", value: pDownloadRegistrationDocumentRq.documentId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadSignedRegistrationDocumentRq_ _uploadSignedRegistrationDocumentRq
   * @returns Promise<UploadSignedRegistrationDocumentRq_>
   * @memberof IossRegistration
   */
  uploadSignedRegistrationDocument(pUploadSignedRegistrationDocumentRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/IossRegistration/Registration/Documents/{documentId}/Signed",
      "POST",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "documentId", value: pUploadSignedRegistrationDocumentRq.documentId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadSignedRegistrationDocumentRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadCertificateRq_ _downloadCertificateRq
   * @returns Promise<DownloadCertificateRq_>
   * @memberof IossRegistration
   */
  downloadCertificate(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/IossRegistration/Registration/Certificate", "GET", "application/json; charset=UTF-8", "application/pdf, application/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadDeregistrationDocumentRq_ _downloadDeregistrationDocumentRq
   * @returns Promise<DownloadDeregistrationDocumentRq_>
   * @memberof IossRegistration
   */
  downloadDeregistrationDocument(options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/IossRegistration/Registration/deregistrationdocument",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
export var DownloadRegistrationDocumentType = /* @__PURE__ */ ((DownloadRegistrationDocumentType2) => {
  DownloadRegistrationDocumentType2["Unsigned"] = "Unsigned";
  DownloadRegistrationDocumentType2["Signed"] = "Signed";
  return DownloadRegistrationDocumentType2;
})(DownloadRegistrationDocumentType || {});
